import React, { createContext, useContext, useMemo, useState, ReactNode } from 'react';

type WorkProfileEditFocusContextValue = {
    activeEditKey: string | null;
    setActiveEditKey: (key: string | null) => void;
};

const WorkProfileEditFocusContext = createContext<WorkProfileEditFocusContextValue | null>(null);

export function WorkProfileEditFocusProvider({ children }: { children: ReactNode }) {
    const [activeEditKey, setActiveEditKey] = useState<string | null>(null);
    const value = useMemo(
        () => ({ activeEditKey, setActiveEditKey }),
        [activeEditKey],
    );
    return <WorkProfileEditFocusContext.Provider value={value}>{children}</WorkProfileEditFocusContext.Provider>;
}

export function useWorkProfileEditFocus() {
    return useContext(WorkProfileEditFocusContext);
}
